<h2 mat-dialog-title>Tax Preview</h2>

<mat-dialog-content>
  @if (loading) {
    <p>Loading tax data...</p>
  } @else if (error) {
    <p style="color:red">{{ error }}</p>
  } @else if (rows.length === 0) {
    <p>No tax data found for the selected statements.</p>
  } @else {
    <div style="overflow-x:auto">
      <table class="nacha-preview-table">
        <thead>
          <tr>
            <th>Property</th>
            <th>Owner</th>
            <th>Period</th>
            <th class="tax-col">
              GET
              <button class="nacha-btn" [disabled]="allBatched('GET')" (click)="openNachaSteps('GET')">
                Generate NACHA ↓
              </button>
            </th>
            <th class="tax-col">
              TAT
              <button class="nacha-btn" [disabled]="allBatched('TAT')" (click)="openNachaSteps('TAT')">
                Generate NACHA ↓
              </button>
            </th>
            <th class="tax-col">
              MCTAT
              <button class="nacha-btn" [disabled]="allBatched('MCTAT')" (click)="openNachaSteps('MCTAT')">
                Generate NACHA ↓
              </button>
            </th>
            <th>Total Tax</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.ownerStmtId) {
            <tr>
              <td>{{ row.propertyCode }}</td>
              <td>{{ row.ownerName }}</td>
              <td>{{ row.stmtYear }}-{{ row.stmtMonth | number:'2.0-0' }}</td>

              <!-- GET -->
              <td class="amount-cell">
                @if (getAmount(row, 'GET') > 0) {
                  <span>{{ getAmount(row, 'GET') | currency }}</span>
                  @if (getBatchId(row, 'GET')) {
                    <span class="batched-badge" title="Batch #{{ getBatchId(row, 'GET') }}">Batched ✓</span>
                  }
                } @else {
                  <span class="no-tax">—</span>
                }
              </td>

              <!-- TAT -->
              <td class="amount-cell">
                @if (getAmount(row, 'TAT') > 0) {
                  <span>{{ getAmount(row, 'TAT') | currency }}</span>
                  @if (getBatchId(row, 'TAT')) {
                    <span class="batched-badge" title="Batch #{{ getBatchId(row, 'TAT') }}">Batched ✓</span>
                  }
                } @else {
                  <span class="no-tax">—</span>
                }
              </td>

              <!-- MCTAT -->
              <td class="amount-cell">
                @if (getAmount(row, 'MCTAT') > 0) {
                  <span>{{ getAmount(row, 'MCTAT') | currency }}</span>
                  @if (getBatchId(row, 'MCTAT')) {
                    <span class="batched-badge" title="Batch #{{ getBatchId(row, 'MCTAT') }}">Batched ✓</span>
                  }
                } @else {
                  <span class="no-tax">—</span>
                }
              </td>

              <td class="total-cell">{{ getTotalTax(row) | currency }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
